import { render } from "./Before_Access_Checkout.vue?vue&type=template&id=5aeb4e3c&scoped=true"
import script from "./Before_Access_Checkout.vue?vue&type=script&lang=js"
export * from "./Before_Access_Checkout.vue?vue&type=script&lang=js"

import "./Before_Access_Checkout.vue?vue&type=style&index=0&id=5aeb4e3c&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aeb4e3c"]])

export default __exports__